export const solutionErrorMessages: { [key: string]: string } = {
  PSALMS: 'Try "Psalm"',
  'OBADIAH1:': 'Remove the chapter number and colon',
  'PHILEMON1:': 'Remove the chapter number and colon',
  '2JOHN1:': 'Remove the chapter number and colon',
  '3JOHN1:': 'Remove the chapter number and colon',
  'JUDE1:': 'Remove the chapter number and colon',
}
